import axios from "axios";
import getFakeLabelsGraficoDiario from "../../utils/getFakeLabelsGraficoDiario";
import getFakeSeriesGraficoDiario from "../../utils/getFakeSeriesGraficoDiario";
import tiposConsulta from "./emuns/tiposConsulta";

/**
 * @param {Object} payload
 * @param {Date} payload.startDate
 * @param {Date} payload.endDate
 * @param {String} payload.canal
 * @param {String} payload.type
 * @returns {Promise}
 *
 * Realiza un request para solicitar los datos del gráfico diario
 */

 export default function getGraficoDiarioData({ startDate, endDate, canal, type }) {
  return new Promise((resolve, reject) => {
    axios.post(serverRoutes.consultaServicios, {
      fecha_inicio: startDate,
      fecha_termino: endDate,
      canal,
      tipo: type,
      tipo_consulta: tiposConsulta.diario,
    }).then((response) => {
            const { data } = response;
            const [graficoData] = data;

            const series = graficoData.series.map(serie => {
                return {
                ...serie,
                group: serie.type,
                }
            })
            const labels = graficoData.labels
            const titulos = ['Gráfico diario'];

            resolve({ series, labels, titulos });

        }).catch((err)=>{
            reject({err});
        })
    })
}
